import { useEffect, useState } from 'react'
import { getLocalPrice } from '../utils/localCurrency'

type LocalPrice = ReturnType<typeof getLocalPrice>

export function useLocalPrice(): LocalPrice {
  const [local, setLocal] = useState<LocalPrice>(null)
  useEffect(() => {
    setLocal(getLocalPrice())
  }, [])
  return local
}
